import { useCallback } from "react";
import { api } from "@tripian/core";

const useDiscoverSearchAutoComplete = (cityId?: number) => {
  const searchPoiAutoCompleteTags = useCallback(
    (searchPoiCategories?: number[]) => {
      if (!cityId) {
        return Promise.resolve([]);
      }

      return api
        .poisSearchAutoCompleteTags(cityId, searchPoiCategories?.join(","))
        .then((tagList: { id: number; name: string }[]) => {
          const filtered = tagList.filter(
            tag => tag.name && tag.name.trim().length > 0
          );

          const options = filtered.map(tag => ({
            value: tag.name,
            label: tag.name,
          }));

          return options;
        })
        .catch(() => {
          return [];
        });
    },
    [cityId]
  );

  return {
    searchPoiAutoCompleteTags,
  };
};

export default useDiscoverSearchAutoComplete;